import { Context } from '#store/overmind';
import { ContentType, PlaylistItem } from '#types/generated/graphql-types';

export const initPlayerV2 = (
  { state }: Context,
  payload: {
    iri: string;
    contentType?: ContentType;
    series?: { episodes: PlaylistItem[] };
    onNextEpisode?: () => void;
  }
) => {
  state.playerV2.contentType = payload.contentType || null;
  state.playerV2.mediaIri = payload.iri;
  state.playerV2.series = payload.series || null;

  if (payload.onNextEpisode) {
    state.playerV2.onNextEpisode = payload.onNextEpisode;
  }

  state.playerV2.visible = true;
};

/**
 * Updates only the media IRI.
 * Use this when you want to switch content without resetting the whole player context.
 */
export const updateMediaIri = ({ state }: Context, iri: string) => {
  state.playerV2.mediaIri = iri;
};

export const setOnNextEpisodeCallback = (
  { state }: Context,
  callback?: () => void
) => {
  state.playerV2.onNextEpisode = callback;
};

// TODO: deprecated, remove
export const disposePlayer = ({ state }: Context) => {
  console.info("[TODO: DEPRECATED] disposePlayer called")
  state.playerV2.visible = false;
  state.playerV2.contentType = null;
  state.playerV2.mediaIri = null;
  state.playerV2.onNextEpisode = null;
  state.playerV2.series = null;
};

// Fully resets all player state. The Video.js instance will be destroyed
// when MediaPlayerWrapper unmounts BasePlayer in response to visible = false.
export const destroyPlayer = ({ state }: Context) => {
  console.info("destroyPlayer called")
  state.playerV2.visible = false;
  state.playerV2.contentType = null;
  state.playerV2.mediaIri = null;
  state.playerV2.onNextEpisode = null;
  state.playerV2.series = null;
};

// Hides the player UI and pauses playback, but keeps the instance alive.
// Use this when you want to temporarily hide the player (e.g. opening a modal).
export const hidePlayer = ({ state }: Context) => {
  console.info("hidePlayer called")
  state.playerV2.visible = false;
};

export const showPlayer = ({ state }: Context) => {
  state.playerV2.visible = true;
};
